import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';

export function ExpandableTruncatedText({ text }: { text: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="block w-full min-w-0 flex-1 truncate text-left">{text}</span>
      </TooltipTrigger>
      <TooltipContent className="max-w-sm whitespace-pre-wrap text-left">{text}</TooltipContent>
    </Tooltip>
  );
}
